import { LitElement, html, utils, broadcastReceiver } from '@hh/global.js'

class HHProduct extends LitElement {
  connectedCallback() {
    super.connectedCallback()

    this.productForm = this.querySelector('.js-info-form')
    this.productInfoBar = this.querySelector('.js-info-bar')
    this.productBottomSheet = this.querySelector('hh-bottom-sheet')
    this.productGalleryEnd = this.querySelector('.js-product-media-wrapper-end')
    this.personalizationInputs = this.querySelectorAll(
      '.js-personalization-input'
    )
    this.personalizationText = this.querySelector('.js-personalization-text')

    this.personalizationInputs.forEach((input) => {
      input.addEventListener('input', this.handleCustomizerUpdate.bind(this))
    })

    this._sizeGuideLoaded = false

    this.sizeGuideReceiver = broadcastReceiver('size-guide', (...args) => {
      this.classList.add('has-size-guide')
    })

    if (!utils.isTablet()) return

    if (this.productForm && this.productInfoBar) {
      this.setInitialBottomSheetHeight()
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.sizeGuideReceiver.disconnect()
    this.galleryObserver.disconnect()
  }

  showBottomSheetOnGalleryEnd() {
    if (this.productGalleryEnd) {
      this.galleryWasAbove = false
      this.galleryObserver = new IntersectionObserver(
        this.handleIntersection.bind(this),
        {
          rootMargin: '0px 0px -200px 0px',
        }
      ).observe(this.productGalleryEnd)
    }
  }

  async setInitialBottomSheetHeight() {
    const undefinedElements =
      this.productInfoBar.querySelectorAll(':not(:defined)')
    const undefinedElementsPromises = [
      ...undefinedElements,
      this.productBottomSheet,
    ].map((node) => customElements.whenDefined(node.localName))

    // Wait for all the undefined elements to be upgraded
    await Promise.all(undefinedElementsPromises)

    this.resizeBottomSheet(
      this.productInfoBar.getBoundingClientRect().height,
      true
    )
  }

  resizeBottomSheet(value, setMinimum = false) {
    this.productBottomSheet.forceSheetHeight(value, setMinimum)
  }

  toggleOptions(event) {
    event.target.remove()

    this.productForm.classList.remove('collapsed-on-mobile')
    const barHeight = this.productInfoBar.getBoundingClientRect().height
    const visibleBottomSheet = this.productBottomSheet.sheetHeight

    if (barHeight > parseInt(visibleBottomSheet, 10)) {
      this.resizeBottomSheet(
        this.productInfoBar.getBoundingClientRect().height,
        true
      )
    } else {
      this.productBottomSheet.setMinimumHeight(barHeight)
    }
  }

  handleIntersection = (entries, observer) => {
    const isAbove = entries[0].boundingClientRect.y < entries[0].rootBounds.y

    if (entries[0].isIntersecting && !this.galleryWasAbove) {
      customElements.whenDefined('hh-bottom-sheet').then(() => {
        this.productBottomSheet.forceSheetHeight(window.innerHeight)
      })
    }

    this.galleryWasAbove = isAbove
  }

  handleCustomizerUpdate(event) {
    const validatedInput = event.target.value
      .replace(/[^@#_$\- \w]+/g, '')
      .toUpperCase()

    this.personalizationInputs.forEach((input) => {
      input.value = validatedInput
    })

    this.personalizationText.textContent = validatedInput
  }

  render() {
    return html`<slot @toggleOptions="${this.toggleOptions}"></slot>`
  }
}

customElements.define('hh-product', HHProduct)
